// extracted by mini-css-extract-plugin
export default {"header":"DYje_As4E2J1tQL7wbdu","container":"HQXe0ZtrxBGbq97EaACs","question":"WE1v1jz2RNM8WSSnvnCE"};